/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React     from 'react';
import styles    from './Tabs.scss';

export default class Tabs extends React.Component {
  constructor() {
    super();
    this.state = {
      fto: true
    };
  }

  handleClick(v) {
    if (this.props.current !== v) {
      this.props.onChange(v)
    }

    this.setState({ fto: false })
  }

  render() {
    let labels = this.props.labels;
    let values = this.props.values;

    let buttons = [];


    for (let v in values) {
      buttons.push(
        <a
          key={values[v]}
          className={v == this.props.current ? styles.current : null}
          onClick={this.handleClick.bind(this, v)} >

          {labels ? labels[v] : values[v]}
        </a>
      );
    }

    return (
      <div className={styles.tabs}>
        {buttons}
      </div>
    );
  }
}
